import styled from "styled-components";

const Icon = styled.svg`
  width: 2vh;
  height: 2vh;
  cursor: pointer;
`;

export default Icon;